import React from 'react';

import { useRouteMatch } from 'react-router-dom';

import Message from 'components/Message';
import RecommendedStoriesCarousel from 'components/RecommendedStoriesCarousel';
import Typography from 'components/Typography';

interface IProps {
  storyId: string;
}

const SimilarStories = ({ storyId }: IProps) => {
  const {
    params: { section = '' },
  } = useRouteMatch<{ section?: string }>();

  return (
    <div className="SimilarStories flex flex-col gap-4 p-0">
      <div className="header">
        <Typography variant="h3">
          <Message message={{ id: 'components.SimilarStories.title' }} />
        </Typography>
      </div>

      <RecommendedStoriesCarousel
        recommendationComponentName={'player.similarAudios'}
        queryVariables={{ storyId }}
        endpoint={section}
        matomoTrackingCategory="play_next_audio_suggestions"
      />
    </div>
  );
};

export default SimilarStories;
